import React, { useState } from "react";
import {
  Box,
  Button,
  IconButton,
  Modal,
  Snackbar,
  Alert,
  Typography
} from "@mui/material";
import { Close } from "@mui/icons-material";
import styled from "@emotion/styled";
import { TextField } from "@mui/material";
import { addCoupon } from "../../api/userApi";

const StyledTextField = styled(TextField)(({ theme }) => ({
  input: {
    color: "#FCFCFC"
  },
  "& .MuiOutlinedInput-root": {
    border: "2px dotted #A4A4A4",
    "& fieldset": {
      color: "#9CA3AF"
    },
    "&:hover fieldset": {
      borderColor: "#FCFCFC",
      border: "none"
    },
    "&.Mui-focused fieldset": {
      color: "#9CA3AF",
      borderColor: "#FCFCFC",
      border: "none"
    }
  }
}));

const CouponModal = ({ open, onClose }) => {
  const [inputCouponValue, setInputCouponValue] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleCouponChange = (event) => {
    const existing = event.target.value.toUpperCase();
    setInputCouponValue(existing);
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleApplyCoupon = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
      if (!inputCouponValue) return;
      const { sessionUrl, message } = await addCoupon(inputCouponValue);
      if (sessionUrl) window.location.href = sessionUrl;
      else {
        setSnackbarMessage(message);
        setOpenSnackbar(true);
        setTimeout(() => {
          onClose();
          handleCloseSnackbar();
        }, 3000);
      }
    } catch (err) {
      setSnackbarMessage(err.error);
      setOpenSnackbar(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal disableAutoFocus disableEnforceFocus open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          padding: "10px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          borderRadius: 3,
          background: "#1C1C1C",
          color: "#FCFCFC",
          transform: "translate(-50%, -50%)",
          width: { xs: "90%", sm: "500px" }
        }}
      >
        <Snackbar
          open={openSnackbar}
          autoHideDuration={3000}
          onClose={handleCloseSnackbar}
        >
          <Alert
            onClose={handleCloseSnackbar}
            severity={
              snackbarMessage?.includes("success" || "Success")
                ? "success"
                : "error"
            }
            sx={{ width: "100%", top: 0, right: 0 }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
        <Box
          display="flex"
          justifyContent="end"
          alignItems="flex-end"
          width="100%"
        >
          <IconButton
            sx={{
              svg: {
                fill: "#FCFCFC"
              }
            }}
            onClick={(e) => {
              onClose();
            }}
          >
            <Close />
          </IconButton>
        </Box>
        <Typography fontSize={"24px"} fontWeight={600}>
          Apply Coupon
        </Typography>
        <Box
          display="flex"
          flexDirection="column"
          gap={3}
          width={"100%"}
          padding={2}
        >
          <StyledTextField
            fullWidth
            value={inputCouponValue}
            variant="outlined"
            name="coupon"
            placeholder="Enter the coupon code"
            margin="normal"
            onChange={handleCouponChange}
          />
          <Button
            fullWidth
            sx={{
              backgroundColor: "#368AD0",
              textTransform: "none",
              fontWeight: "bold"
            }}
            variant="contained"
            onClick={handleApplyCoupon}
          >
            Apply now
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default CouponModal;
